import React, { useState, useEffect } from 'react';
import './userask.css';
import paperAircraftIcon from './paper-aircraft-1.png';
import RequestSvc from "../../services/RequestSvc";
import { BASE_API_URL } from "../../utils/Constants";

const UserAsk = ({ onSubmit }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [user, setUser] = useState({});

    const fetchUserData = async () => {
        let svc = new RequestSvc();
        let result = await svc.get(`${BASE_API_URL}userProfile`).catch((err) => console.log(err));
        if (result?.error) {
            console.log("Failed to fetch user data");
        } else {
            setUser(result?.data);
        }
    };

    /* loading user data  */
    useEffect(() => {
        fetchUserData();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            console.log('Search query:', searchQuery);
            if (onSubmit) {
                onSubmit(searchQuery); // Pass query to parent for transition
            }
        }
    };

    const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div className="userask-container">
            <div className="userask-content">
                <h1 className="userask-greeting">  
                    Hola {user?.Nombre} 
                </h1>
                
                <form onSubmit={handleSubmit} className="userask-form">
                    <div className="userask-input-container">
                        <input
                            type="text"
                            placeholder="¿Qué quieres encontrar?"
                            value={searchQuery}
                            onChange={handleInputChange}
                            className="userask-input"
                        />
                        <button
                            type="submit"
                            className="userask-submit-btn"
                            disabled={!searchQuery.trim()}
                        >
                            <span className="userask-submit-icon" >
                                <img src={paperAircraftIcon} alt="Submit" />
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserAsk;